<template>
  <div v-loading="loading">
    <div class="maintitle">{{ $route.meta.title }}</div>
    <el-divider></el-divider>
    <el-row :gutter="10" class="text-left">
      <el-col :span="6">
        <el-input v-model="id" placeholder="请输入会员id" size="mini" @change="resetInfo"></el-input>
      </el-col>
      <el-button @click="getInfo" size="mini">查询会员信息</el-button>
      <el-button @click="addContent" type="success" v-if="detail.id" size="mini">新建内容</el-button>
      <span class="margin-left">{{ detail.company }}</span>
    </el-row>
    <div v-if="detail.id">
      <el-tabs v-model="status" @tab-click="tabsClick">
        <el-tab-pane v-for="item in statusList" :key="item.value" :name="item.value" :label="item.label"></el-tab-pane>
      </el-tabs>
      <el-table border :data="list">
        <el-table-column label="内容Id" prop="contentId" width="170"></el-table-column>
        <el-table-column label="内容标题" prop="title"></el-table-column>
        <el-table-column label="内容标签" prop="tagName" width="100"></el-table-column>
        <el-table-column label="预览" width="100">
          <template v-slot="scope">
            <el-button type="text" @click="openUrl(scope.row.landUrl)" v-if="scope.row.landUrl">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column label="关联商品" width="140">
          <template v-slot="scope">
            <el-button type="text" @click="showGoods(scope.row.goodsIds)">共关联{{ scope.row.goodsIds.length }}个商品
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" prop="operateTime" width="170"></el-table-column>
        <el-table-column label="操作">
          <template v-slot="scope">
            <el-button size="mini" @click="mdfy(scope)" type="primary" v-if="status !=='online' && status !== 'publishing'">编辑</el-button>
            <el-button size="mini" @click="deleteContent(scope)" type="danger" v-if="status !=='online' && status !== 'publishing'">删除</el-button>
            <el-button size="mini" @click="setStatus(scope,'unavailable')" type="danger" v-if="status==='online'">下线</el-button>
            <el-button size="mini" @click="setStatus(scope,'online')" type="success" v-if="status ==='unavailable'">上线</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background :current-page="page" :page-sizes="pagesizes" :page-size="pagesize"
                     @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
    <el-dialog :visible.sync="addDiv" :show-close="false" width="80%" :close-on-click-modal="false"
               @close="resetContentInfo">
      <el-form :label-width="formLabelWidth" class="padding-left text-left">
        <el-form-item label="内容标签">
          <div class="tag-list">
            <div v-for="(item,index) in tagList" :key="index" @click="contentInfo.tagId=item.value"
                 :class="contentInfo.tagId===item.value?'crnt':''">{{ item.label }}
            </div>
          </div>
        </el-form-item>
        <el-form-item label="内容标题">
          <el-input v-model="contentInfo.title" maxlength="30" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="内容描述">
          <el-input v-model="contentInfo.content" type="textarea" maxlength="400" show-word-limit rows="5"></el-input>
        </el-form-item>
        <el-form-item label="选择图片">
          <el-button @click="showMaterial(2)">选择图片</el-button>
          <!--          <div v-if="contentInfo.images.length<=10" class="flex" style="justify-content: flex-start">-->
          <!--            <upload-to-oss ref="refuploadoss" @success="showRes" @uploading="showloading" accept=".jpg,.jpeg,.png,.webp"-->
          <!--                           path="images" hasDate-->
          <!--                           btnText="图片"></upload-to-oss>-->
          <!--            <span-->
          <!--                class="margin-left">建议上传宽高比为1:1的480*480像素及以上的图片，图片大小控制在10MB以内，支持格式png、jpg、jpeg、webp</span>-->
          <!--          </div>-->
          <div v-if="contentInfo.images.length>0" class="content-media">
            <div v-for="(item,index) in contentInfo.images" :key="index">
              <el-image fit="contain" class="content-image" :src="item.url"
                        :preview-src-list="getFile(contentInfo.images)"></el-image>
              <div class="delete" @click="deleteMedia('images',index)"><i class="el-icon-delete"
                                                                          style="color:white"></i></div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="选择视频">
          <el-button @click="showMaterial(3)">选择视频</el-button>
          <!--          <div v-if="contentInfo.videos.length===0" class="flex" style="justify-content: flex-start">-->
          <!--            <upload-to-oss ref="refuploadoss" @success="showRes" @uploading="showloading" accept=".mpeg,.mp4"-->
          <!--                           path="videos" hasDate-->
          <!--                           btnText="视频"></upload-to-oss>-->
          <!--            <div class="margin-left" style="line-height: 20px">-->
          <!--              <p>1、建议上传宽高比为1:1、时长在30秒以上、大小不超过10MB</p>-->
          <!--              <p>2、建议上传与所选标签和内容相关的视频，能正常播放、无卡顿</p>-->
          <!--            </div>-->
          <!--          </div>-->
          <div v-if="contentInfo.videos.length>0" class="content-media">
            <div v-for="(item,index) in contentInfo.videos" :key="index">
              <video class="content-image" @click="showMaterailVideo(item.url)" style="cursor: pointer">
                <source :src="item.url" type="video/mp4">
              </video>
              <div class="delete" @click="deleteMedia('videos',index)"><i class="el-icon-delete"
                                                                          style="color:white"></i></div>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="关联商品">
          <div class="flex" style="justify-content: flex-start">
            <el-button @click="showGoodsList" type="primary" plain>选择商品</el-button>
            <div class="margin-left" v-if="contentInfo.goodsIds.length>0">关联{{
                contentInfo.goodsIds.length
              }}个商品
            </div>
          </div>
        </el-form-item>
        <!--        <el-form-item label="选择附件">-->
        <!--          <el-button @click="selectMaterial(4)">选择附件</el-button>-->
        <!--        </el-form-item>-->
        <el-form-item label="选择附件">
          <el-button @click="showMaterial(4)">选择附件</el-button>
<!--          <div v-if="contentInfo.attachments.length<=10" class="flex" style="justify-content: flex-start">-->
<!--            <upload-to-oss ref="refuploadoss" @success="showRes" @uploading="showloading" accept=".pdf,.jpg,.png"-->
<!--                           path="attachments" hasDate-->
<!--                           btnText="附件"></upload-to-oss>-->
<!--            <div class="margin-left" style="line-height: 20px">-->
<!--              <p>1、可上传产品说明书、图册等，将会在内容页、商品详情页等页面展示给买家</p>-->
<!--              <p>2、建议文件大小控制在10MB以内，支持pdf、jpg、png格式</p>-->
<!--            </div>-->
<!--          </div>-->
          <div v-if="contentInfo.attachments.length>0" class="content-attachment">
            <div v-for="(item,index) in contentInfo.attachments" :key="index">
              <div><i class="el-icon-paperclip"></i>{{ item.fileName }}</div>
              <div class="delete" @click="deleteMedia('attachments',index)">
                <i class="el-icon-close"></i>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDiv = false">取 消</el-button>
        <el-button type="primary" @click="submit('saveDraft')">保存草稿</el-button>
        <el-button type="primary" @click="submit('publish')">发布</el-button>
      </div>
    </el-dialog>
    <el-drawer title="商品列表" :visible.sync="drawer" direction="rtl" size="50%" :before-close="setGoodsList">
      <div class="margin">
        <div class="flex margin-bottom">
          <el-col style="flex:1">
            <el-input size="mini" v-model="keyword" placeholder="请输入商品名称关键词"></el-input>
          </el-col>
          <el-button size="mini" class="margin-left" @click="searchGoods">查询</el-button>
        </div>
        <el-table :data="goodsList" ref="goodList" border @selection-change="goodsSelect">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="商品信息">
            <template v-slot="scope">
              <div class="flex" style="align-items: self-start;justify-content: flex-start">
                <el-image :src="scope.row.canonicalImage" class="goods-thumb" fit="contain"
                          :preview-src-list="[scope.row.canonicalImage]"></el-image>
                <div style="flex: 1;margin-left: 10px">
                  <p>{{ scope.row.name }}</p>
                  <p style="font-size: 12px;color:#faa">{{ scope.row.goods_id }}</p>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background :current-page="goodsPage" :page-size="15" @current-change="goodsPageChange"
                       layout="total, prev, pager, next" :total="goodsTotal"></el-pagination>
      </div>
    </el-drawer>
    <el-dialog v-if="materialDiv" :visible.sync="materialDiv" width="80%" v-loading="materialloading">
      <div class="path-div margin-bottom">
        <div v-for="(item,index) in path" :key="index">
          <div v-if="index<path.length-1">
            <span class="pathname" @click="showMaterial(crntFileType,item)">{{ item.name }}</span>
            <span>&nbsp;>&nbsp;</span>
          </div>
          <div v-else>{{ item.name }}</div>
        </div>
        <div class="margin-big-left flex">
          <el-button @click="pathNameDiv=true" type="success" plain>新建文件夹</el-button>
          <upload-to-oss @success="showRes" @uploading="showloading" :accept="accept"
                         :path="fileType" hasDate :btnText="typeName"
                         class="margin-left"></upload-to-oss>
          <div class="margin-left text-left" v-if="crntFileType===3" style="line-height: 20px">
            <p>1、建议上传宽高比为1:1、时长在30秒以上、大小不超过10MB</p>
            <p>2、建议上传与所选标签和内容相关的视频，能正常播放、无卡顿</p>
          </div>
          <div class="margin-left text-left" v-if="crntFileType===2" style="line-height: 20px">
            <p>建议上传宽高比为1:1的480*480像素及以上的图片，图片大小控制在10MB以内</p>
            <p>支持格式png、jpg、jpeg、webp</p>
          </div>
          <div class="margin-left text-left" v-if="crntFileType===4" style="line-height: 20px">
            <p>1、可上传产品说明书、图册等，将会在内容页、商品详情页等页面展示给买家</p>
            <p>2、建议文件大小控制在10MB以内，支持pdf、jpg、png格式</p>
          </div>
        </div>
      </div>
      <div class="imglist">
        <div v-if="path[path.length-1].id !== 0">
          <img src="/static/images/pre.png" alt="">
          <p>返回上一级</p>
          <div class="cover-div" @click="showMaterial(crntFileType,path[path.length-2])"></div>
        </div>
        <div v-for="(item,index) in materialList" :key="index">
          <img src="/static/images/folder.png" alt="" v-if="item.fileType===1">
          <el-image :src="item.url" alt="" v-if="item.fileType===2" fit="contain" lazy></el-image>
          <!--          <img src="/static/images/video.png" alt="" v-if="item.fileType===3">-->
          <video v-if="item.fileType===3">
            <source :src="item.url" type="video/mp4">
          </video>
          <img src="/static/images/pdf.png" alt="" v-if="item.fileType===4">
          <p><span>{{ item.fileName }}</span><span v-if="item.fileType!==1">.{{ item.fileExt }}</span></p>
          <div class="cover-div" v-if="item.fileType===1" @click="showMaterial(crntFileType,item)"></div>
          <div class="cover-div" v-if="item.fileType!==1 && crntparam !== 'spec'" @click="changeSelect(item)"></div>
          <div class="view-div" v-if="item.fileType===2" @click="showMaterailPic(item.url)">预览</div>
          <div class="view-div" v-if="item.fileType===3" @click="showMaterailVideo(item.url)">预览</div>
          <div class="selected" v-if="item.fileType===crntFileType && checkExit(item.url)">
            <img src="/static/images/selected.png">
          </div>
        </div>
      </div>
      <el-dialog width="80%" :visible.sync="materialVisble" append-to-body>
        <img :src="crntMaterail" style="width:90%;margin-left:5%;margin-top:20px">
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" type="primary" @click="materialVisble=false">关 闭</el-button>
        </div>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="materialDiv=false">关 闭</el-button>
      </div>
    </el-dialog>
    <el-dialog width="80%" :visible.sync="materialVideoVisble">
      <video :src="crntMaterail" style="width:640px;height:480px;" controls></video>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="materialVideoVisble=false">关 闭</el-button>
      </div>
    </el-dialog>
    <el-dialog title="文件夹名称" :visible.sync="pathNameDiv" width="300px" @closed="pathname=''">
      <el-input v-model='pathname' placeholder="请输入文件夹名称"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="pathNameDiv=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="addPath">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import uploadToOss from "@/components/uploadToOss.vue";

export default {
  components: {
    uploadToOss,
  },
  data() {
    return {
      id: '',
      detail: {},
      loading: false,
      list: [],
      page: 1,
      status: 'online',
      statusList: [],
      total: 0,
      contentInfo: {
        attachments: [],
        behavior: '',
        content: '',
        contentId: '',
        goodsIds: [],
        images: [],
        tagId: '',
        title: '',
        videos: [],
        status: ''
      },
      addDiv: false,
      tempInfo: {},
      drawer: false,
      goodsPage: 1,
      goodsTotal: 0,
      keyword: '',
      goodsList: [],
      goodsTemp: [],
      tagList: [],
      materialDiv: false,
      materialloading: false,
      path: [{id: 0}],
      toggleSelect: false,
      materialPage: 1,
      materialKeyword: '',
      materialList: [],
      materialTotal: 0,
      pathNameDiv: false,
      pathname: '',
      crntparam: '',
      crntMaterail: '',
      materialVisble: false,
      crntFileType: '',
      materialVideoVisble: false
    }
  },
  watch: {
    contentInfo: {
      handler(newVal, oldVal) {
        if (newVal.goodsIds.length > 100) {
          this.$message({
            type: 'error',
            message: '关联商品不能超过100个'
          })
          this.contentInfo.goodsIds = newVal.goodsIds.splice(0, 100);
          console.log(this.contentInfo.goodsIds)
          this.toggleSelection()
        }
      },
      deep: true
    }
  },
  computed: {
    fileType() {
      switch (this.crntFileType) {
        case 2:
          return 'images';
        case 3:
          return 'videos';
        case 4:
          return 'attachments';
      }
    },
    accept() {
      switch (this.crntFileType) {
        case 2:
          return '.jpg,.jpeg,.png,.webp';
        case 3:
          return '.mpeg,.mp4';
        case 4:
          return '.pdf,.jpg,.png';
      }
    },
    typeName(){
      switch (this.crntFileType) {
        case 2:
          return '图片';
        case 3:
          return '视频';
        case 4:
          return '附件';
      }
    }
  },
  methods: {
    showloading() {
      this.loading = true;
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.page = 1;
      this.getList();
    },
    handleCurrentChange(p) {
      this.page = p;
      this.getList();
    },
    goodsPageChange(p) {
      // this.contentInfo.goodsIds = this.goodsTemp.map(item => item.id)
      this.goodsPage = p;
      this.getGoodsList()
    },
    getInfo() {
      if (this.id === '') {
        this.$message({
          type: 'error',
          message: '请输入会员member_id'
        })
        return;
      }
      this.loading = true;
      this.$axios({
        url: this.HOST + "/admin.index/getMemberInfo",
        method: "post",
        data: {
          member_id: this.id
        }
      }).then(res => {
            this.loading = false;
            if (res.data.status === 1) {
              this.detail = res.data.detail;
              this.tempInfo = JSON.parse(JSON.stringify(this.contentInfo));
              this.contentInfo.status = this.status;
              this.getList()
            }
          }
      )
    },
    getList() {
      this.loading = true;
      this.$axios({
        url: this.HOST + "/admin.industrycontent/list",
        method: "post",
        data: {
          member_id: this.detail.member_id,
          area: this.detail.area,
          page: this.page,
          size: this.pagesize,
          status: this.status
        }
      }).then(res => {
        this.loading = false;
        if (res.data.status === 1) {
          this.list = res.data.list.list;
          this.total = res.data.list.total;
        }
      })
    },
    getInitInfo() {
      this.loading = true;
      this.$axios({
        url: this.HOST + "/admin.industrycontent/getStatusList",
        method: "post",
        data: {}
      }).then(res => {
        this.loading = false;
        if (res.data.status === 1) {
          this.statusList = res.data.statusList;
          this.tagList = res.data.tagList;
        }
      })
    },
    tabsClick(e) {console.log(e)
      this.resetList();
      this.getList();
    },
    resetInfo() {
      this.detail = {}
      this.resetList()
    },
    resetList() {
      this.page = 1;
      this.total = 0;
      this.list = [];
      // this.status = 'online'
    },
    addContent() {
      this.addDiv = true;
    },
    showGoods(goodsList) {

    },
    resetContentInfo() {
      const temp = JSON.parse(JSON.stringify(this.tempInfo));
      for (let item in this.contentInfo) {
        this.contentInfo[item] = temp[item]
      }
    },
    showRes(res) {
      this.$axios({
        url: this.HOST + '/admin.index/uploadFileToBaidu',
        method: 'post',
        data: {
          file: res.host + '/' + res.fileUrl,
          area: this.detail.area
        }
      }).then(rest => {
            this.loading = false;
        if (rest.data.status === 1) {
          this.$axios(({
            url:this.HOST + '/admin.index/uploadMaterail',
            method: 'post',
            data:{
              member_id: this.detail.member_id,
              area: this.detail.area,
              parentId:this.path[this.path.length - 1].id,
              fileType:this.crntFileType,
              fileName:res.name,
              url:rest.data.file
            }
          })).then(result=>{
            if(result.data.status ===1){
              this.$message({
                type: 'success',
                message:result.data.info
              })
              this.materialList.push({
                fileType: this.crntFileType,
                fileName: res.name,
                id: result.data.id,
                url:rest.data.file
              });
            }
          })
          // if (res.path === 'attachments') {
          //   this.loading = false;
          //   this.contentInfo[res.path].push({
          //     url: rest.data.file,
          //     fileName: res.name
          //   });
          // } else {
          //   // this.contentInfo[res.path].push({
          //   //   url: rest.data.file
          //   // });
          //
          // }
        }
      })
    },
    uploadMaterial(res){
      this.$axios({
        url: this.HOST + '/admin.index/uploadFileToBaidu',
        method: 'post',
        data: {
          file: res.host + '/' + res.fileUrl,
          area: this.detail.area
        }
      }).then(rest => {
        this.loading = false;
        if (rest.data.status === 1) {
          if (res.path === 'attachments') {
            this.contentInfo[res.path].push({
              url: rest.data.file,
              fileName: res.name
            });
          } else {
            this.contentInfo[res.path].push({
              url: rest.data.file
            });
          }
        }
      })
    },
    getFile(list) {
      return list.map(item => {
        return item.url;
      })
    },
    submit(behavior) {
      this.contentInfo.behavior = behavior;
      this.loading = true;
      this.$axios({
        url: this.HOST + '/admin.industrycontent/save',
        method: 'post',
        data: {
          info: this.contentInfo,
          member_id: this.detail.member_id,
          area: this.detail.area,
          status: this.status,
        }
      }).then(res => {
        this.loading = false;
        if (res.data.status === 1) {
          this.$message({
            type:'success',
            message:res.data.info
          })
          this.addDiv = false;
          this.getList();
        }
      })
    },
    showGoodsList() {
      this.drawer = true;
    },
    getGoodsList() {
      this.$axios({
        url: this.HOST + '/admin.index/getGoodsList',
        method: 'post',
        data: {
          member_id: this.detail.member_id,
          area: this.detail.area,
          page: this.goodsPage,
          size: 15,
          query: this.keyword,
          status: 'online'
        }
      }).then(res => {
        if (res.data.status === 1) {
          this.toggleSelect = true;
          this.goodsList = res.data.list.list;
          this.goodsTotal = res.data.list.total;
          this.$nextTick(() => {
            this.toggleSelection()
          })
        }
      })
    },
    searchGoods() {
      this.resetGoodsList();
      this.getGoodsList()
    },
    resetGoodsList() {
      this.goodsPage = 1;
      this.goodsList = [];
      this.goodsTotal = 0;
      // this.goodsTemp = [];
    },
    goodsSelect(val) {
      if (this.toggleSelect) return;
      const tempList = this.goodsList.map(item => item.goods_id)
      const temp = this.contentInfo.goodsIds.filter(item => !tempList.includes(item))
      this.contentInfo.goodsIds = temp.concat(val.map(item => item.goods_id))
    },
    setGoodsList(done) {
      // this.contentInfo.goodsIds = this.goodsTemp.map(item => item.id)
      this.resetGoodsList()
      // this.goodsTemp = [];
      done()
    },
    toggleSelection() {
      this.toggleSelect = true;
      this.$refs.goodList.clearSelection();
      this.goodsList.forEach(item => {
        if (this.contentInfo.goodsIds.includes(item.goods_id)) {
          this.$refs.goodList.toggleRowSelection(item)
        }
      })
      this.toggleSelect = false;
    },
    deleteMedia(str, index) {
      this.contentInfo[str].splice(index, 1)
    },
    openUrl(url) {
      window.open(url, "_blank");
    },
    mdfy(scope) {
      this.loading = true;
      this.$axios({
        url: this.HOST + '/admin.industrycontent/detail',
        method: 'post',
        data: {
          contentId: scope.row.contentId,
          status: this.status,
          member_id: this.detail.member_id,
          area: this.detail.area,
        }
      }).then(res => {
        this.loading = false;
        if (res.data.status === 1) {
          for (let item in this.contentInfo) {
            this.contentInfo[item] = res.data.detail[item] || scope.row[item] || '';
          }
          console.log(this.contentInfo)
          this.addDiv = true;
        }
      })
    },
    // 获取素材，type为素材类型：1文件夹；2图片；3视频；4pdf
    // pid为父目录id
    showMaterial(type, item = {id: 0}) {
      this.crntFileType = type;
      console.log(type)
      this.materialloading = true;
      this.$axios({
        url: this.HOST + "/admin.index/getMaterial",
        method: "post",
        data: {
          fileType: type,
          parentId: item.id,
          member_id: this.detail.member_id,
          query: this.materialKeyword,
          area: this.detail.area
        },
      }).then((res) => {
        this.materialloading = false;
        if (res.data.status === 1) {
          if (item.id === 0) {
            this.path = [
              {
                id: 0,
                name: "根目录",
              },
            ];
          } else {
            let crnt = -1;
            for (let i in this.path) {
              if (this.path[i].id === item.id) {
                crnt = i;
                break;
              }
            }
            if (crnt === -1) {
              this.path.push({
                id: item.id,
                name: item.fileName,
              });
            } else {
              this.path.splice(parseInt(crnt) + 1);
            }
          }
          this.materialList = res.data.list;
          // this.materialTotal = res.data.list.total;
          this.materialDiv = true;
        }
      });
    },
    selectMaterial(type) {

    },
    addPath() {
      if (this.pathname === "") return;
      this.$axios({
        url: this.HOST + "/admin.index/uploadMaterail",
        method: "post",
        data: {
          fileName: this.pathname,
          member_id: this.detail.member_id,
          area: this.detail.area,
          parentId:this.path[this.path.length - 1].id,
          fileType:1,
        },
      }).then((res) => {
        if (res.data.status === 1) {
          this.materialList.push({
            fileType: 1,
            fileName: res.data.name,
            id: res.data.id,
          });
          this.pathNameDiv = false;
        }
      });
    },
    changeSelect(item) {
      for (let i in this.contentInfo[this.fileType]) {
        if (this.contentInfo[this.fileType][i].url === item.url) {
          this.contentInfo[this.fileType].splice(i, 1);
          return;
        }
      }
      switch(this.crntFileType){
        case 2:
          if (this.contentInfo.images.length >= 10) {
            this.$message({
              type: 'error',
              message: '最多选择10张图片'
            })
            return;
          }
          this.contentInfo.images.push({
            url: item.url
          });
          return;
        case 3:
          this.contentInfo.videos = [{
            url: item.url
          }];
          return;
        case 4:
          this.contentInfo.attachments.push({
            url: item.url,
            fileName: item.fileName
          });
      }
    },
    showMaterailPic(url) {
      this.crntMaterail = url;
      this.materialVisble = true;
    },
    showMaterailVideo(url) {
      this.crntMaterail = url;
      this.materialVideoVisble = true;
    },
    checkExit(url) {
      for (let item of this.contentInfo[this.fileType]) {
        if (item.url === url) {
          return true;
        }
      }
      return false;
    },
    deleteContent(scope){
      this.$confirm(`确定要删除行业内容吗？本操作不可恢复`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios({
          url: this.HOST + "/admin.industrycontent/delete",
          method: "post",
          data: {
            area:this.detail.area,
            member_id:this.detail.member_id,
            contentId:scope.row.contentId,
            status:this.status
          },
        }).then((res) => {
          if (res.data.status === 1) {
            this.$message({
              type:'success',
              message:res.data.info
            })
            this.list.splice(scope.$index,1)
          }
        });
      });
    },
    setStatus(scope,status){
      this.$axios({
        url: this.HOST + "/admin.industrycontent/setStatus",
        method: "post",
        data: {
          area:this.detail.area,
          member_id:this.detail.member_id,
          contentId:scope.row.contentId,
          status:status
        },
      }).then((res) => {
        if (res.data.status === 1) {
          this.$message({
            type:'success',
            message:res.data.info
          })
          this.list.splice(scope.$index,1)
        }
      });
    }
  },
  mounted() {
    this.getInitInfo()
  }
}
</script>
<style>
.content-media {
  display: flex;
  flex-wrap: wrap;

  > div {
    position: relative;
    margin: 5px;

    > .content-image {
      border: 1px solid #E5E5E5;
      border-radius: 10px;
      aspect-ratio: 1;
      width: 100px;
    }

    > .delete {
      opacity: 0;
      position: absolute;
      top: 0;
      right: 0;
      width: 30%;
      aspect-ratio: 1;
      background: rgba(0, 0, 0, 0.5);
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      cursor: pointer;
      display: flex;
    }

    &:hover > .delete {
      opacity: 1;
    }
  }
}

.content-attachment {
  display: flex;

  > div {
    display: flex;
    margin: 5px;

    > .delete {
      margin-left: 5px;
      cursor: pointer;
      opacity: 0;
    }

    &:hover > .delete {
      opacity: 1;
    }
  }
}

.goods-thumb {
  width: 60px;
  aspect-ratio: 1;
  border-radius: 10px;
}

.tag-list {
  display: flex;

  > div {
    background-color: #EDEDF0;
    padding: 0 5px;
    border-radius: 5px;
    margin: 5px;
    cursor: pointer;

    &.crnt {
      background-color: #EBF3FF;
      color: #0067FF;
    }
  }
}

.path-div {
  display: flex;
  align-items: center;

  .pathname:hover {
    color: #409EFF;
    cursor: pointer;
  }
}

.imglist {
  display: flex;
  flex-wrap: wrap;

  > div {
    width: 12%;
    min-width: 150px;
    position: relative;
    border-radius: 10px;
    overflow: hidden;
    margin: 5px;
    border: 1px solid #E5E5E5;
    box-sizing: border-box;

    &:hover {
      > .cover-div {
        display: block;
      }

      > .view-div {
        display: block;
      }
    }

    > img, .el-image, video {
      width: 100%;
      aspect-ratio: 1;
    }

    > .cover-div {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
      display: none;
      background-color: rgba(0, 0, 0, 0.5);
    }

    > .view-div {
      position: absolute;
      bottom: 17px;
      display: none;
      text-align: center;
      width: 100%;
      background-color: rgba(255, 255, 255, 0.7);
      cursor: pointer;
    }

    .selected {
      position: absolute;
      top: 0;
      right: 0;
      width: 50px;
      height: 50px;

      > img {
        width: 100%;
      }
    }
  }
}
</style>